import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTransferDetailsIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 26,
	viewBox: "0 0 20 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M19.4996 22.6031C19.4996 23.7077 18.6041 24.6031 17.4996 24.6031H3C1.89543 24.6031 1 23.7077 1 22.6031V3.00024C1 1.89567 1.89543 1.00024 3 1.00024H12.5157C13.3113 1.00024 14.0744 1.31631 14.637 1.87892L18.6209 5.86281C19.1835 6.42542 19.4996 7.18848 19.4996 7.98413V22.6031Z",
			stroke: "#85A0AD",
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.4997 7.74125H13.7584C13.2061 7.74125 12.7584 7.29353 12.7584 6.74125V3",
			stroke: "#85A0AD",
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4 13.2068H16",
			stroke: "#FF3131",
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4 16.3962H11.8445",
			stroke: "#FF3131",
			strokeMiterlimit: 10
		})
	]
});
export default SvgTransferDetailsIcon;
